export enum ContextMenuActionEnum {
  NEW_DIRECTORY = 'newDirectory',
  UPLOAD_FILE = 'uploadFile',
  UPLOAD_DIRECTORY = 'uploadDirectory',
  DELETE = 'delete',
  RENAME = 'rename',
  RELOAD = 'reload'
}
